<app-error-notification></app-error-notification>
<router-outlet></router-outlet>

<footer *ngIf="!isRunningInElectron">
    <div class="footer-container desktop" [ngClass]="{'safari-only': isSafari}">
        <div>
            <p>
                <a href="https://krematorium-am-limes.de/" target="_blank">Krematorium am Limes GmbH</a>
            </p>
            <p>Alte Römerstraße 8<br>74706 Osterburken</p>
        </div>
        <div>
            <p>
                <a href="tel:06291647970">06291 - 647970</a>
                <br>
                <a href="mailto:info&#64;krematorium-am-limes.de">info&#64;krematorium-am-limes.de</a>
            </p>
        </div>
        <div>
            <!-- Spacer -->
        </div>
        <div>
            <p>
                <a href="https://krematorium-am-limes.de/impressum/" target="_blank">Impressum</a>
                <br>
                <a href="https://krematorium-am-limes.de/datenschutz/" target="_blank">Datenschutz</a>
                <br>
                <a onclick="openContactModal()" class="cursor-pointer">Kontakt</a>
            </p>
        </div>
    </div>
    <ul id="privacy" class="dropdown-content privacy-dropdown">
        <li>
            <a href="https://krematorium-am-limes.de/datenschutz/" target="_blank">
                Krematorium am Limes
            </a>
        </li>
    </ul>
    <!--   needed for mobile dropdown.. -->
    <ul id="privacy2" class="dropdown-content privacy-dropdown">
        <li>
            <a href="https://krematorium-am-limes.de/datenschutz/" target="_blank">
                Krematorium am Limes
            </a>
        </li>
    </ul>
    <!-- Mobile footer -->
    <div class="footer-container mobile" [ngClass]="{'safari-only': isSafari}">
        <div style="display: flex; flex-direction: column; flex-grow: 1">
            <div style="flex-grow: 1; padding-top: 10px">
                <p style="margin: 0; margin-bottom: -6px">
                    <a href="tel:06291647970">06291 - 647970</a>
                    <br>
                    <a href="mailto:info&#64;krematorium-am-limes.de">info&#64;krematorium-am-limes.de</a>
                </p>
            </div>
            <div>
                <p>Krematorium am Limes GmbH<br>Alte Römerstraße 8<br>74706 Osterburken</p>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; flex-grow: 1">
            <div style="align-self: flex-end; padding-top: 10px; flex-grow: 1">
            </div>
            <div style="align-self: flex-end">
                <p>
                    <a href="https://krematorium-am-limes.de/impressum/" target="_blank">Impressum</a>
                    <br>
                    <a href="https://krematorium-am-limes.de/datenschutz/" target="_blank">Datenschutz</a>
                    <br>
                    <a onclick="openContactModal()" class="cursor-pointer">Kontakt</a>
                </p>
            </div>
        </div>
    </div>
</footer>

<div id="contactModal" class="modal">
    <div class="modal-content column">
        <div class="contact-title row space-between center">
            <h1 class="redesign action">
                Kontakt
            </h1>
            <i onclick="closeModalWithID('contactModal')" class="material-icons cursor-pointer">close</i>
        </div>

        <div class="row space-between center">
            <div class="input-field col s12 l6 contact-input" style="width: auto">
                <select [(ngModel)]="salutation" id="inputClientSalutation"
                    class="inputClientSalutation contact-input browser-default">
                    <option value="0" selected>Anrede</option>
                    <option value="100">Herr</option>
                    <option value="101">Frau</option>
                    <option value="201">Familie</option>
                    <option value="202">Ordnungsamt</option>
                </select>
            </div>

            <div class="input-field col s12 l6 contact-input" style="flex-grow: 1">
                <input id="name" [(ngModel)]="name" type="text" required>
                <label for="name" class="active">Vollständiger Name</label>
            </div>
        </div>

        <div class="row space-between center">
            <div class="input-field col s12 l6 contact-input" style="flex-grow: 1">
                <input id="mail" [(ngModel)]="mail" type="text" required>
                <label for="mail" class="active">E-Mail</label>
            </div>

            <div class="input-field col s12 l6 contact-input" style="flex-grow: 1">
                <input id="phone" [(ngModel)]="phone" type="text">
                <label for="phone" class="active">Telefon</label>
            </div>
        </div>

        <div class="input-field col s12" style="width: 100%">
            <textarea id="msg" [(ngModel)]="msg" class="materialize-textarea message" style="margin-bottom: 30px"
                required></textarea>
            <label for="msg" class="active">Nachricht</label>
        </div>

        <h2 class="redesign action prefixed" (click)="sendMail()">Abschicken</h2>
    </div>
</div>